import React from 'react';
import { useParams } from 'react-router-dom';
import DeclarationNewEdit from './declarationNewEdit/DeclarationNewEdit';
import DeclarationRead from './declarationRead/DeclarationRead';
import NewEventService from '../shared/services/NewEvent.service';
import {INewEvent} from '../event/interface';
import {usersRoleAllowToEnterInEditMode} from '../shared/models/records';
import {LoggingServie} from '../shared/services/LoggingService';
import {Flow, UserRoles} from '../shared/models/enums';
import SessionStorageTokenService from '../shared/helpers/SessionStorageTokenService';
import LocalStorageTokenService from "../shared/helpers/SessionStorageTokenService";
import {GetEventStatusLabel} from "../shared/helpers/HelpersBusiness";
import {EventStatus} from "../dashboard/interface";
import { DeclarationInterface } from "./declarationNewEdit/interfaces";

interface Props {
    isCancelled?: boolean
    event?: any
    declaration?: DeclarationInterface
}

interface StateProps {
    event: INewEvent | null,
    declaration: DeclarationInterface | null,
    isReadOnly?: boolean,
    loading: boolean
}

class DeclarationInner extends React.Component<Props, StateProps> {
    constructor(props: Props) {
        super(props);
        this.state = {
            event: this.props.event || null,
            declaration: this.props.declaration || null,
            isReadOnly: undefined,
            loading: !this.props.event
        }
    }

    canEdit = (role: UserRoles): boolean => {
        return usersRoleAllowToEnterInEditMode.includes(role) || this.canMaisonSecEdit(role);
    }

    canMaisonSecEdit = (role: UserRoles): boolean => {

        if (role !== UserRoles.maisonsec) {
            return false;
        }
        const eventCreatedBy = this.state.event?.createdBy;
        const label = this.state.event?.eventsStatus ? GetEventStatusLabel(this.state.event.eventsStatus) as EventStatus : null;

        return (
            label === EventStatus.pendingMaison ||
            (eventCreatedBy != null && eventCreatedBy === LocalStorageTokenService.getUserNameToken())
        );
    }

    isEventCancelled = () => {
        const eventStstusLen = this.state.event?.eventsStatus?.length;
        if(this.state.event?.eventsStatus && eventStstusLen && eventStstusLen > -1) return this.state.event.eventsStatus[eventStstusLen-1].status?.flow.id === Flow.Cancelled;
        return false;
    }

    componentDidMount() {
        if(this.state.event?.eventsStatus) {
            this.setState({
                isReadOnly: !this.canEdit(SessionStorageTokenService.getUserRoleToken() as UserRoles),
                loading: false
            })
        }
        if(this.state.event && !this.state.event.eventsStatus) {
            const eventId = Number(this.state.event.id);
            NewEventService.getById(eventId).subscribe(res => {
                this.setState({
                    event: res,
                    loading: false
                })
        }, (error) => { LoggingServie.LogError(error, ''); })
        }
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }

        return (
            <div>
                {this.state.isReadOnly !== undefined && (
                    <div>
                        {this.state.event && this.state.isReadOnly ? (
                            <React.Fragment>
                                {this.state.event && (
                                    <DeclarationRead event={this.state.event} declaration={this.state.declaration} isCancelled={this.props.isCancelled} />
                                )}
                            </React.Fragment>
                        ) : (
                            <DeclarationNewEdit isCancelled={this.isEventCancelled()} props={{
                                event: this.state.event,
                                declaration: this.state.declaration,
                                isCancelled: this.props.isCancelled
                            }}/>
                        )}
                    </div>
                )}
        </div>

        )
    }
}

// Wrapper component that handles route params
const Declaration = (props: Props) => {
    const params = useParams();
    const [event, setEvent] = React.useState<INewEvent | null>(props.event || null);
    const [loading, setLoading] = React.useState(!props.event);

    React.useEffect(() => {
        if (!props.event && params.id) {
            const eventId = Number(params.id);
            NewEventService.getById(eventId).subscribe(
                (res) => {
                    setEvent(res);
                    setLoading(false);
                },
                (error) => {
                    LoggingServie.LogError(error, '');
                    setLoading(false);
                }
            );
        }
    }, [props.event, params.id]);

    if (loading) {
        return <div>Loading...</div>;
    }

    const declaration = props.declaration || (event?.eventDeclarations?.[0] as DeclarationInterface);

    return (
        <DeclarationInner
            event={event}
            declaration={declaration}
            isCancelled={props.isCancelled ?? false}
        />
    );
};

export default Declaration;